import React from "react";
import { connect } from "react-redux";
import Configuration from "../../../config";
import Form from "../../../components/Form";
import Icon from "../../../components/Icon";
import Modal from "../../../components/Modal";
import { message } from "../../../actions";
import { resetMonthlyLimit, setMonthlyLimit } from "../../../actions/Users";

const mapStateToProps = ( state ) =>
{
	return {
		user: state.user
	};
};

const mapDispatchToProps = ( dispatch ) =>
{
	return {
		setMonthlyLimit: ( formData ) =>
		{
			dispatch( setMonthlyLimit( formData ) );
		},
		resetMonthlyLimit: () =>
		{
			dispatch( resetMonthlyLimit() );
		},
		message: ( a_message, a_type, a_timeout ) =>
		{
			dispatch( message( a_message, a_type, a_timeout ) );
		}
	};
};

/**
 * Komponente um statische Inhalte auszugeben
 */
class PriceBox extends React.Component
{
	constructor( props )
	{
		super( props );
		
		this.handleLimit = this.handleLimit.bind( this );
		this.resetLimit = this.resetLimit.bind( this );
		
	} // function constructor(...)
	
	handleLimit( a_event, a_form_ref )
	{
		a_event.preventDefault();
		
		if ( this.refs.hasOwnProperty( a_form_ref ) )
		{
			const formData = this.refs[a_form_ref].state;
			this.props.setMonthlyLimit( formData );
		}
		
		return false;
		
	} // function handleLimit(...)
	
	resetLimit( a_event )
	{
		a_event.preventDefault();
		
		this.props.resetMonthlyLimit();
		
	} // function resetLimit(...)
	
	render()
	{
		const { user, message } = { ...this.props };
		
		if ( !user.organization || Object.keys( user.organization ).length <= 0 )
		{
			return <div/>;
		}
		
		const organization = user.organization;
		const surveyCosts = organization.survey_costs && parseFloat( organization.survey_costs );
		const organizationLimit = organization.monthly_limit ? organization.monthly_limit : "-";
		const basicCharge = organization.basic_charge && parseFloat( organization.basic_charge );
		
		return <div className={"priceBox current"}>
			<div className={"price white secondary-color-text tRight"}>
				<div className={"crossBlock"}>
					<div className={"inlineBlock margin-right"}>
						<div className={"exoLightFont"}>Angelegte Recherchen</div>
						<span className={"value primary-color-text"} title={"Recherchekosten für diesen Monat"}>
								{surveyCosts && ( surveyCosts ).toLocaleString( Configuration.location, Configuration.priceString )}
							</span>
						<span className={"additional secondary-color-text"}> Euro <span className="form-element-required red-text">*</span></span>
					</div>
					<div className={"inlineBlock margin-left"}>
						<div className={"exoLightFont"}>+ Grundgebühr</div>
						<span className={"value primary-color-text"} title={"Monatliche Grundgebühr"}>
								{basicCharge && ( basicCharge ).toLocaleString( Configuration.location, Configuration.priceString )}
							</span>
						<span className={"additional secondary-color-text"}> Euro <span className="form-element-required red-text">*</span></span>
					</div>
				</div>
				<div className={"spacerBlock secondary-color-text"}>
					<div className={"exoLightFont"}>Monatliches Kostenlimit</div>
					<Form
						id={`formEditOrganizationLimit${organization.id}`}
						ref={`formEditOrganizationLimit${organization.id}`}
						
						modalTrigger={
							<button className={"btn btn-small btn-flat hover-primary-color primary-color-text hover-white-text left"} title={"Kostenlimit festlegen oder ändern."}>
								<Icon iconName={"edit"}/>
							</button>
						}
						modalClass={"tLeft"}
						modalTitle={"Kostenlimit setzen"}
						className="col s12"
						errorMessage={( a_message, a_type, a_timeout ) => message( a_message, a_type, a_timeout )}
						onSubmit={( event ) => this.handleLimit( event, `formEditOrganizationLimit${organization.id}` )}
						submitValue={[
							<Icon key={`formEditOrganizationLimit${organization.id}-icon`} iconName={"edit"}/>,
							<span key={`formEditOrganizationLimit${organization.id}-text`}>Kostenlimit setzen</span>
						]}
						fields={[
							{
								name: "monthly_limit",
								title: "Monatliches Kostenlimit für Recherchen inkl. Grundgebühr in Euro",
								additionalHtml: [
									<p key={"limit_text"}>Hier können Sie Ihr monatliches Kostenlimit festlegen. Es errechnet sich aus der monatlicher Grundgebühr
										plus den Einzelpreisen der angelegten/durchgeführten Recherchen.</p>,
									<p key={"limit_add_text"}>So haben Sie die Kosten immer fest im Griff.</p>
								],
								type: "number",
								step: "0.01",
								validator: ( a_value ) =>
								{
									if ( isNaN( parseFloat( a_value ) ) )
									{
										return "Bitte geben Sie einen gültigen Betrag ein.";
									}
									
									if ( !Configuration.currencyRegex.test( a_value ) )
									{
										return "Das Kostenlimit darf höchstens 4 Nachkommastellen enthalten.";
									}
									
									if ( parseFloat( a_value ) < ( surveyCosts + basicCharge ) )
									{
										return "Das Kostenlimit muss überhalb der aktuellen Kosten liegen.";
									}
									return true;
								}
							}
						]}
						values={{ monthly_limit: organizationLimit }}
					/>
					{
						organization.monthly_limit &&
						<Modal
							className={"confirm"}
							key={"organization_limit"}
							trigger={<button className="btn btn-small btn-flat hover-red red-text hover-white-text left" title={"Kostenlimit zurücksetzen"}
							                 key={"reset_limit"}>
								<Icon iconName={"delete"}/>
							</button>}
							footer={
								<React.Fragment>
									<button onClick={( event ) => this.resetLimit( event )} data-modal={"confirm"}>
										<Icon size={14} iconName={"delete"}/><span>Kostenlimit zurücksetzen</span>
									</button>
									<button className={"secondary-color"} data-modal={"close"}><Icon iconName={"discard"}/><span>abbrechen</span></button>
								</React.Fragment>
							}
						>
							<p className={"tCenter"}>Soll das Kostenlimit wirklich zurückgesetzt werden?</p>
						</Modal>
					}
					
					<span className={"value primary-color-text"}>
							{organizationLimit === "-"
								? organizationLimit
								: ( parseFloat( organizationLimit ) ).toLocaleString( Configuration.location, Configuration.priceString )}
						</span>
					<span className={"additional secondary-color-text"}> Euro <span className="form-element-required red-text">*</span></span>
				</div>
				<div className={"baseFont taxLabel tLeft secondary-color-text"}><span className="form-element-required red-text">*</span> zzgl. 19% USt.</div>
			</div>
		</div>;
	}
}

PriceBox = connect(
	mapStateToProps,
	mapDispatchToProps
)( PriceBox );

export default PriceBox;